import { BAILocale } from '.';
import tr_TR from 'antd/es/locale/tr_TR';

const localeValue: BAILocale = {
  lang: 'tr',
  antdLocale: tr_TR,
};

export default localeValue;
